import _classCallCheck from "/builds/gcpvn/gcp.vn/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var OneKeyMap = function OneKeyMap() {
  _classCallCheck(this, OneKeyMap);

  this.set = void 0;
  this.get = void 0;
  var key, val;

  this.get = function (k) {
    return k === key ? val : void 0;
  };

  this.set = function (k, v) {
    key = k;
    val = v;
  };
};

export default OneKeyMap;